import { render } from "./ReferralPhysicians.vue?vue&type=template&id=16b09231&ts=true"
import script from "./ReferralPhysicians.ts?vue&type=script&lang=ts&external"
export * from "./ReferralPhysicians.ts?vue&type=script&lang=ts&external"

import "./ReferralPhysicians.vue?vue&type=style&index=0&id=16b09231&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__